<template>
  <div class="logo-container" :class="{ 'logo-container--collapsed': isCollapse }" @click="$emit('refresh')">
    <transition name="fade">
      <span v-if="!isCollapse" class="brand-lockup">
        <img src="@/assets/brand/logo.svg" alt="Logo" class="brand-mark" />
        <span class="brand-name">EasyHire AI</span>
      </span>
      <img v-else src="@/assets/brand/logo.svg" alt="Logo" class="logo-collapse" />
    </transition>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isCollapse: boolean
}>()

defineEmits<{
  (event: 'refresh'): void
}>()
</script>

<style scoped>
.logo-container {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  padding: 8px 12px;
  box-sizing: border-box;
  transition: padding 0.3s ease;
}

.logo-container--collapsed {
  justify-content: center;
  padding: 8px 0;
}

.brand-lockup {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
}

.brand-mark {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  object-fit: contain;
}

.brand-name {
  min-width: 0;
  color: #111827;
  font-size: 17px;
  font-family:
    'Avenir Next',
    Inter,
    'SF Pro Display',
    'Segoe UI',
    system-ui,
    sans-serif;
  font-weight: 750;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
}

.logo-collapse {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
